export function registerServiceWorker(): void {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  let optIn = false;
  try {
    const params = new URLSearchParams(window.location.search);
    optIn = params.get("sw") === "1";
  } catch {
    // ignore — sem query string nao tem opt-in.
  }

  if (!optIn) {
    // Default: desinfeta TVs ja contaminadas com SW de versao anterior.
    // Desregistra qualquer SW existente e dropa caches drclick-panel-*.
    try {
      navigator.serviceWorker
        .getRegistrations?.()
        .then((regs) => {
          regs.forEach((r) => r.unregister().catch(() => {}));
        })
        .catch(() => {});
    } catch {
      // ignore
    }
    if (typeof caches !== "undefined") {
      try {
        caches
          .keys?.()
          .then((keys) => {
            keys
              .filter((k) => k.startsWith("drclick-panel-"))
              .forEach((k) => caches.delete(k).catch(() => {}));
          })
          .catch(() => {});
      } catch {
        // ignore
      }
    }
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        try {
          reg.update().catch(() => {});
        } catch {
          // ignore
        }
      })
      .catch((err) => {
        console.error("[panel:sw_register_failed]", err);
      });
  });
}
